import { PopoverProps } from "antd";
import { StyledPopover } from "./atoms";

export function Popover({ className = "", ...props }: PopoverProps) {
  return (
    <StyledPopover
      className={`renderbus-ui--popover ${className}`}
      getPopupContainer={(triggerNode) => triggerNode}
      trigger="click"
      {...props}
    />
  );
}
